import UserTransaction from 'components/UserTransAction/UserTransaction';

const UserTransactionPage = () => {
	return <UserTransaction />;
};

export default UserTransactionPage;
